export type WorkerRequest = { type: "stream"; id: string; fileName: string; url: string };

export type WorkerResponse =
  | { type: "progress"; id: string; percent: number }
  | { type: "success"; id: string }
  | { type: "error"; id: string; message: string };

export const MODEL_VIEWER_DIRECTORY = "model-viewer-cache";
